import { colors } from 'settings/colors'

export const Separator = () => <div css={{ borderTop: `1px solid ${colors.grey200}` }} />
